import Image from 'next/image';
import classnames from 'classnames';

import LinkedInSVG from '@/svg/icons/linkedin.svg';
import TwitterSVG from '@/svg/icons/twitter.svg';
import GlobeSVG from '@/svg/icons/globe.svg';

export default function StaffCard({
  invert,
  id,
  name,
  title,
  photo,
  imageUrl,
  twitterHandle,
  linkedinUrl,
  websiteUrl,
}) {
  return (
    <div
      key={id}
      className="w-full py-0 md:px-6 h-full md:mb-6 lg:mb-12 md:w-1/2 lg:w-1/3"
    >
      {(photo || imageUrl) && (
        <Image
          src={photo?.url || imageUrl}
          title={name}
          alt={name}
          width={256}
          height={256}
          className="mb-3 rounded"
          objectFit="cover"
        />
      )}

      {name && (
        <p className="font-black text-lg md:text-xl lg:text-2xl leading-snug">
          {name}
        </p>
      )}
      {title && <p className="leading-loose text-sm">{title}</p>}

      {(twitterHandle || linkedinUrl || GlobeSVG) && (
        <div
          className={classnames(
            'flex md:w-2/5 items-center mt-3 mb-6 md:mb-0 -ml-6',
            {
              'text-whisper': !invert,
              'text-mid-gray': invert,
            },
          )}
        >
          {linkedinUrl && (
            <a
              href={linkedinUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="ml-6 fill-current hover:text-cornflower"
            >
              <span className="sr-only">LinkedIn</span>
              <LinkedInSVG className="w-5 h-5" />
            </a>
          )}

          {twitterHandle && (
            <a
              href={`https://twitter.com/${twitterHandle}`}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="ml-6 fill-current hover:text-cornflower"
            >
              <span className="sr-only">Twitter</span>
              <TwitterSVG className="w-5 h-5" />
            </a>
          )}

          {websiteUrl && (
            <a
              href={websiteUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="ml-6 fill-current hover:text-cornflower"
            >
              <span className="sr-only">Website</span>
              <GlobeSVG className="w-5 h-5" />
            </a>
          )}
        </div>
      )}
    </div>
  );
}
